module.exports = __webpack_public_path__ + "static/media/page2image.aa0b8703.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/components/SearchIntro/page2image.png
// module id = 609
// module chunks = 0